import ErrorPage from '../pages/error/[slug]';
import { FunctionComponent } from 'react';

const Error404: FunctionComponent = () => <ErrorPage code="404" />;

export default Error404;
